// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avo__stepper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 13px;
  font-family: "OpenSans-Regular";
}
.avo__stepper.vertical {
  flex-direction: column;
}
.avo__stepper .step-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.5em;
}
.avo__stepper .step-wrapper.vertical {
  flex-direction: column;
  margin-bottom: 0;
  align-items: start;
}
.avo__stepper .step-wrapper.active .circle-icon {
  background-color: #116584;
  color: #ffffff;
}
.avo__stepper .step-wrapper.active .step-item {
  color: #116584;
}
.avo__stepper .step-wrapper.active .line {
  border-color: #116584;
}
.avo__stepper .vertical-content {
  display: flex;
  flex-direction: row;
}
.avo__stepper .circle-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #f9fafb;
  color: #97a2b6;
}
.avo__stepper .step-item {
  margin-left: 0.5rem;
  color: #97a2b6;
}
.avo__stepper .line {
  width: 40px;
  border-width: 1px;
  border-color: #cdd5df;
  margin: 0 0.5rem;
}
.avo__stepper .line.vertical {
  width: 0;
  min-height: 40px;
  height: 100%;
  margin: 0 0.8rem;
}
.avo__stepper .line.solid {
  border-style: solid;
}
.avo__stepper .line.dashed {
  border-style: dashed;
}`, "",{"version":3,"sources":["webpack://./src/components/commons/stepper/stepper.scss","webpack://./src/styles/_color.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,+BAAA;AADF;AAGE;EACE,sBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AAFJ;AAII;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;AAFN;AAMM;EACE,yBCRK;EDSL,cC5BA;ADwBR;AAOM;EACE,cCbK;ADQb;AAQM;EACE,qBCjBK;ADWb;AAWE;EACE,aAAA;EACA,mBAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBChDS;EDiDT,cC7CS;ADmCb;AAaE;EACE,mBAAA;EACA,cClDS;ADuCb;AAcE;EACE,WAAA;EACA,iBAAA;EACA,qBC1DS;ED2DT,gBAAA;AAZJ;AAcI;EACE,QAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAZN;AAeI;EACE,mBAAA;AAbN;AAgBI;EACE,oBAAA;AAdN","sourcesContent":["@import '../../../styles/color';\n\n.avo__stepper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  font-size: 13px;\n  font-family: 'OpenSans-Regular';\n\n  &.vertical {\n    flex-direction: column;\n  }\n\n  .step-wrapper {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: .5em;\n\n    &.vertical {\n      flex-direction: column;\n      margin-bottom: 0;\n      align-items: start;\n    }\n\n    &.active {\n      .circle-icon {\n        background-color: $primary-50;\n        color: $white;\n      }\n\n      .step-item {\n        color: $primary-50;\n      }\n\n      .line {\n        border-color: $primary-50;\n      }\n    }\n  }\n\n  .vertical-content {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .circle-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    background-color: $neutral-10;\n    color: $neutral-50;\n  }\n\n  .step-item {\n    margin-left: 0.5rem;\n    color: $neutral-50;\n  }\n\n  .line {\n    width: 40px;\n    border-width: 1px;\n    border-color: $neutral-30;\n    margin: 0 0.5rem;\n\n    &.vertical {\n      width: 0;\n      min-height: 40px;\n      height: 100%;\n      margin: 0 0.8rem;\n    }\n\n    &.solid {\n      border-style: solid;\n    }\n\n    &.dashed {\n      border-style: dashed;\n    }\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n$primary: #116584;\n$red: #f04438;\n\n$neutral-10: #f9fafb;\n$neutral-20: #ebf0f6;\n$neutral-30: #cdd5df;\n$neutral-40: #b6bfcb;\n$neutral-50: #97a2b6;\n$neutral-60: #788192;\n$neutral-70: #4a5467;\n$neutral-80: #101728;\n$neutral-90: #0a0a0a;\n\n$primary-10: #eef7fa;\n$primary-20: #ddf6ff;\n$primary-30: #a6e7ff;\n$primary-40: #2d96be;\n$primary-50: #116584;\n$primary-60: #07506d;\n$primary-70: #062d3d;\n$primary-80: #052431;\n$primary-90: #041b25;\n$primary-100: #021218;\n$primary-shadow: #073649;\n\n$red-10: #fef3f2;\n$red-20: #fee4e2;\n$red-30: #fecdca;\n$red-40: #fda29b;\n$red-50: #f97066;\n$red-60: #f04438;\n$red-70: #d92d20;\n$red-80: #b42318;\n$red-90: #912018;\n$red-100: #570f04;\n$red-shadow: #f0443840;\n\n$green-10: #F1F8F6;\n$green-20: #CFE6E0;\n$green-30: #B0D6CB;\n$green-40: #82C0AD;\n$green-50: #39987C;\n$green-60: #118462;\n$green-70: #0E6E52;\n$green-80: #0B5841;\n$green-90: #043B2B;\n$green-100: #031A14;\n$green-shadow: #11846240;\n\n$orange-10: #FFF6ED;\n$orange-20: #FFEACA;\n$orange-30: #FEB273;\n$orange-40: #FD853A;\n$orange-50: #FB6514;\n$orange-60: #EC4A0A;\n$orange-70: #C4320A;\n$orange-80: #9C2A10;\n$orange-90: #7E2410;\n$orange-100: #2D160C;\n$orange-shadow: #EC4A0A40;\n\n$blue-10: #F5FAFF;\n$blue-20: #DEEFFF;\n$blue-30: #84CAFF;\n$blue-40: #53B1FD;\n$blue-50: #2E90FA;\n$blue-60: #1570EF;\n$blue-70: #175CD3;\n$blue-80: #1849A9;\n$blue-90: #194185;\n$blue-100: #06214F;\n$blue-shadow: #1570EF40;\n\n$purple-10: #F4EBFF;\n$purple-20: #E9D7FE;\n$purple-30: #D6BBFB;\n$purple-40: #B692F6;\n$purple-50: #9E77ED;\n$purple-60: #7F56D9;\n$purple-70: #6941C6;\n$purple-80: #53389E;\n$purple-90: #42307D;\n$purple-100: #180947;\n$purple-shadow: #6D118440;\n\n$pink-10: #FDF2FA;\n$pink-20: #FFDEF5;\n$pink-30: #FAA7E0;\n$pink-40: #F670C7;\n$pink-50: #EE46BC;\n$pink-60: #DD2590;\n$pink-70: #C11574;\n$pink-80: #9E165F;\n$pink-90: #851651;\n$pink-100: #851651;\n$pink-shadow: #DD259040;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
